(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'assetTypeMenu',
            [
                'SECTIONS',
                AssetTypeMenuFactory
            ]
        );

    // Factory Method
    function AssetTypeMenuFactory(SECTIONS)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            scope: false,
            templateUrl: SECTIONS.PREFIX + SECTIONS.ACCOUNT.ASSET_TYPE + SECTIONS.POSTFIX
        };

    }
})();



